const mutations = {
    setColor(state,color){
        state.color = color
    }
}
export default mutations;